import { render } from "./UserSignUp.vue?vue&type=template&id=230c860c"
import script from "./UserSignUp.vue?vue&type=script&lang=js"
export * from "./UserSignUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__